//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../Features/Features.SelectFeature.js";
import "../Features/Features.SelectFeatureList.js";
import "../Features/Features.VDVMirrorListItemBuilder.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AxisPair",1,1],[0,"ColorFOV",1,0],[0,"ColorROI",1,0],[0,"CreateROI",1,0],[1,"Depth",0,"Expression",0],[1,"DistanceToBox",0,"Expression",0],[1,"ExtensionLength",0,"Expression",0],[1,"Height",0,"Expression",0],[1,"HorizontalOffset",0,"Expression",0],[1,"Mirror",0,"Features.SelectFeature",1],[0,"MirrorOrientation",1,1],[1,"Obstructions",0,"Features.SelectFeatureList",0],[1,"SelectVisionDevice",0,"Features.SelectFeature",0],[0,"TargetPoint",1,"Point",0],[0,"TranslucencyFOV",1,0],[0,"TranslucencyROI",1,0],[0,"UseViewDirection",1,0],[1,"VDVMirrorItem",0,"Features.VDVMirrorListItemBuilder",0],[1,"VerticalOffset",0,"Expression",0],[0,"ViewDirectionMethod",1,0],[0,"ViewDirectionVector",1,"Direction",0],[0,"VisionDeviceType",1,0],[1,"Width",0,"Expression",0],[0,"WindowBodies",1,"ScCollector",0],[1,"XRotation",0,"Expression",1],[1,"YRotation",0,"Expression",1],[1,"ZRotation",0,"Expression",1]],[],[]];
SPLM.Features.ViewVolumeBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ViewVolumeBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ViewVolumeBuilder.VisionDeviceTypes = Object.freeze({
    "VDVCamera" : "VDVCamera", "RotatingPointer" : "RotatingPointer", "DirectVision" : "DirectVision", "VDVMirror" : "VDVMirror"});

SPLM.Features.ViewVolumeBuilder.MirrorOrientations = Object.freeze({
    "AutoRotation" : "AutoRotation", "Interactive" : "Interactive"});

SPLM.Features.ViewVolumeBuilder.AxisPairs = Object.freeze({
    "Zy" : "Zy", "Xy" : "Xy"});

export default SPLM;